import * as types from "./types";

export const getExportApplicantsRequest = (payload) => ({
  type: types.GET_APPLICANTS_EXPORT_REQUEST,
  payload,
});

export const getExportApplicantsResponse = (payload) => ({
  type: types.GET_APPLICANTS_EXPORT_RESPONSE,
  payload,
});
